import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import PasswordField from "../../components/account/PasswordField";
import SpinnerIcon from "../../components/global/SpinnerIcon";
import { updatePassword } from "../../store/actions/UserActions";

/*
    SECURITY — the old "Change Password" modal as a page.

    The validation is the modal's, with one bug fixed on the way across: the
    modal called setLoading(true) before validating, then returned early on
    every failure path without ever setting it back, so a mistyped
    confirmation left the Update button spinning until the page was reloaded.
    Loading is now only entered once the request is actually going out.
*/
const Security = () => {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const [values, setValues] = useState({
    current: "",
    next: "",
    confirm: "",
  });

  const handleChange = ({ target: { name, value } }) =>
    setValues((prev) => ({ ...prev, [name]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!values.current || !values.next || !values.confirm) {
      toast.error("Please fill in all three password fields");
      return;
    }
    if (values.next !== values.confirm) {
      toast.error("New Password and Confirm Password not the same");
      return;
    }
    if (values.current === values.next) {
      toast.warn("Password not changed");
      return;
    }

    setSaving(true);
    /*
        Released in `finally`, not in the success callback. updatePassword
        toasts its own failure and does not call back on error, so a callback
        that only runs on success leaves the button spinning forever after a
        wrong current password. The thunk is an async function, so dispatch
        hands back its promise and both outcomes land here.
    */
    dispatch(
      updatePassword(
        { oldPassword: values.current, password: values.next },
        () => {
          toast.success("Password updated successfully");
          setValues({ current: "", next: "", confirm: "" });
        }
      )
    ).finally(() => setSaving(false));
  };

  return (
    <>
      <h1 className="account__heading">Password</h1>
      <p className="account__description">
        To update your password, just type in your current one and choose a new
        one. Once you submit, your new password will be ready to use right away.
      </p>

      <div className="account__panel">
        <form className="account__form" onSubmit={handleSubmit} noValidate>
          <PasswordField
            label="Current Password"
            name="current"
            value={values.current}
            onChange={handleChange}
            autoComplete="current-password"
            disabled={saving}
          />
          <PasswordField
            label="New Password"
            name="next"
            value={values.next}
            onChange={handleChange}
            autoComplete="new-password"
            disabled={saving}
          />
          <PasswordField
            label="Password again please"
            name="confirm"
            value={values.confirm}
            onChange={handleChange}
            autoComplete="new-password"
            disabled={saving}
          />

          <button
            type="submit"
            className="gb-btn gb-btn--primary"
            disabled={saving}
          >
            {saving ? (
              <>
                <SpinnerIcon /> Updating
              </>
            ) : (
              "Update"
            )}
          </button>
        </form>
      </div>
    </>
  );
};

export default Security;
